<style>
.password-enter-wrapper-box {
  width: 40%;
  padding: 15px;
  margin: 40px auto 0;
  border-radius: 6px;
}
.product-logo-wrap {
  width: 180px;
  height: 40px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.password-box label {
  width: 100%;
  font-size: 14px;
  color: #1e1f26;
  font-weight: 600;
  margin: 0;
}
.password-box label span {
  color: #f00;
}
.password-box input[type="password"] {
  width: 100%;
  height: 45px;
  border: 1px solid #dfdfdf;
  padding: 0 15px;
  color: #1e1f26;
  font-weight: 500;
  font-size: 16px;
  border-radius: 5px;
}
.submit-pwd-btns input[type="submit"] {
  border: none;
  display: inline-block;
  background: #cf2031;
  color: #fff;
  padding: 6px 30px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
}

.submit-pwd-btns a {
  display: inline-block;
  padding: 6px 30px;
  background: #eee;
  font-size: 14px;
  font-weight: 600;
  color: #1e1f26;
  border-radius: 4px;
  margin-left: 6px;
}
.submit-pwd-btns {
  text-align: center;
}
</style>
<style scoped>
.btn-feel {
  border: none;
  display: inline-block;
  background-color: #cf2031 !important;
  color: #fff;
  padding: 6px 30px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
}
@media(max-width:575px){
  .password-enter-wrapper-box{
    width:100%;
  }
}
</style>
<template>
  <div class="container">
    <header style="margin-top: 5%">
      <div class="container-fluid">
        <v-row style="text-align: center" justify="center" class="h2 pt-2">
          Reset your password
        </v-row>
        <v-row
          style="text-align: center; font-weight: 400"
          justify="center"
          class="pt-2"
        >
          Enter a new password below
        </v-row>
      </div>
    </header>
    <v-row no-gutters justify="center">
      <div class="password-enter-wrapper-box">
        <!-- <div class="product-logo-wrap">
        <img src="../assets/Images/on-air-logo.png" />
      </div> -->

        <div class="password-box mt-0">
          <label class="pb-2" style="font-weight: 400">New Password</label>
          <input
            type="password"
            id="txtNewPassword"
            value=""
            name=""
            class="mb-3"
            tabindex="1"
            :placeholder="$t('myprofile.placeholdernewpassword')"
          />

          <label class="pb-2" style="font-weight: 400"
            >Confirm New Password</label
          >
          <input
            type="password"
            id="txtConfirmNewPassword"
            value=""
            name=""
            @keyup.enter="changePassword()"
            :placeholder="$t('myprofile.placeholderconfirmPwd')"
            tabindex="2"
          />
          <span id="spnPwdLabel"></span>
          <div class="submit-pwd-btns mt-3">
            <v-row>
              <v-col>
                <v-btn
                  block
                  type="button"
                  @click="$router.push('/')"
                  tabindex="-1"
                  >Cancel</v-btn
                >
                <!-- <a  style="margin: 0; width: 100%" href="/">Cancel</a> -->
              </v-col>
              <v-col>
                <!-- <input
                  style="margin: 0; width: 100%"
                  type="submit"
                  value="Submit"
                  id="btnChangePwd"
                  v-on:click="changePassword()"
                /> -->
                <v-btn
                  class="btn-feel"
                  style="
                    font-size: 16px;
                    font-weight: 700;
                    background: #288af2 !important;
                    color: #fff !important;
                  "
                  :loading="changePasswordButtonLoading"
                  @click="changePassword()"
                  block
                  tabindex="3"
                  >Submit</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-row>
    <!-- Othe msg  Modal -->
    <div class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              An error occurred during authentication. Please try again.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Othe msg  Modal Ends-->
    <!-- Success Modal -->
    <div class="modal fade all-modal" id="success-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <span
              class="
                success-icon
                d-flex
                justify-content-center
                align-items-center
              "
            >
              <img src="../assets/Images/icons/tick.svg" />
            </span>
            <p>
              <strong>Password changed successfully!</strong>
            </p>
            <br />
            <p>
              <span class="btn-pink sussecc-btn" v-on:click="goForLogin"
                >Login Now</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Success Modal Ends-->
  </div>
</template>

<script>
//import GoogleSignInButton from "vue-google-signin-button-directive";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
//import firebase from "firebase";
import "firebase/auth";
import axios from "axios";
import router from "../router";
import APIs from "../components/APIInit";
//import store from "../store";
var self;
export default {
  data: () => ({
    changePasswordButtonLoading: false,
    requestToken: "",
    BannerURL: "",
    showLogin: false,
    btnBackColor: "",
    btntextColor: "",
    result: "",
    client: "",
    EmailURL: "",
    DynamicColor: "",
    arrEvents: [],
    hostExistcnt: 0,
    Loginloaded: false,
    pageBg: null,
    brandlogo: null,
    loginButtonFillColor: "#f00",
    loginButtonTextColor: "#fff",
  }),
  components: {
    //ForgotPassword
  },
  computed: {},
  beforeDestroy() {},

  mounted() {
    debugger;
    self = this;
    $("#topmenu").hide();
    $("#leftmenu").hide();
    debugger;
    self.requestToken = this.$route.query.rt;
    self.EventsData = [];
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      //self.hostName = "neche2020am.e2m.live";
      self.hostName = "uatbni.e2m.live";
      //self.hostName = "network.travelgyaan.com";
      // this.result = "tci.e2m.live";
      //this.result = "uatcapitalgroup.e2m.live";
    } else {
      self.hostName = location.host;
    }
    var path;
    console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = "https://resources.e2m.live/e2monair.appspot.com/";
    }

    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        //  self.eventcollectionname = "OA_UAT_" + self.clientID + self.evntId;
        console.log(self.clientID);
        console.log(self.clientName);
        self.getButtonBranding(self.hostName);
        db.collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(self.clientID)
          .get()
          .then(function (doc) {
            var data = doc.data();
            console.log(data);
            debugger;
            self.clientLogoUrl = data.LoginAssets.logo;
            self.ClientName = data.ClientName;
            self.clientProfile = data.Company;
            //     self.BannerURL = data.EventListAssets.banner2048x88;
          });
        /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      });

    //self.checkout();
  },
  methods: {
    goForLogin: function () {
      $("#success-modal").modal("hide");
      router.push({ name: "Login" });
    },
    changePassword() {
      let that = this;
      this.changePasswordButtonLoading = true;
      document.getElementById("spnPwdLabel").innerHTML = "";

      if (document.getElementById("txtNewPassword").value == "") {
        this.changePasswordButtonLoading = false;

        document.getElementById("spnPwdLabel").innerHTML = self.$t(
          "myprofile.newpwdvalidmsg"
        );

        $("#spnPwdLabel").css("color", "red");
        return;
      }
      if (document.getElementById("txtConfirmNewPassword").value == "") {
        document.getElementById("spnPwdLabel").innerHTML = self.$t(
          "myprofile.confirmpwdvalidmsg"
        );
        $("#spnPwdLabel").css("color", "red");
        this.changePasswordButtonLoading = false;

        return;
      }

      var newPassword = document.getElementById("txtNewPassword").value;
      var confirmPassword = document.getElementById(
        "txtConfirmNewPassword"
      ).value;
      if (document.getElementById("txtNewPassword").value.length < 6) {
        document.getElementById("spnPwdLabel").innerHTML = self.$t(
          "myprofile.placeholdernewpassword"
        );
        $("#spnPwdLabel").css("color", "red");
        this.changePasswordButtonLoading = false;

        return;
      }
      if (document.getElementById("txtNewPassword").value.length > 16) {
        document.getElementById("spnPwdLabel").innerHTML = self.$t(
          "myprofile.placeholdernewpassword"
        );
        $("#spnPwdLabel").css("color", "red");
        this.changePasswordButtonLoading = false;

        return;
      }

      debugger;

      //-------------------- Confirm password ---------------------

      if (
        document.getElementById("txtConfirmNewPassword").value != newPassword
      ) {
        document.getElementById("spnPwdLabel").innerHTML = self.$t(
          "myprofile.confirmandnewpwdmatchvalidmsg"
        );
        $("#spnPwdLabel").css("color", "red");
        this.changePasswordButtonLoading = false;

        return;
      }
      //-----------------------------------------------------------

      //----------------------------------------------------------------------------------------------------
      //var hostUrl = location.host.toLowerCase();
      // var apiUrl = "";
      // var xAPIkey = "";
      // if (hostUrl.includes("localhost")) {
      //   apiUrl = "https://uat-awsapi.e2m.live/reset-password";
      //   xAPIkey = "DACp6AMlLD3zPL3CXRCvU9hlGEierp7m6xdJLOlH";
      // } else if (hostUrl.includes("uat")) {
      //   apiUrl = "https://uat-awsapi.e2m.live/reset-password";
      //   xAPIkey = "DACp6AMlLD3zPL3CXRCvU9hlGEierp7m6xdJLOlH";
      // } else if (hostUrl.includes("stage")) {
      //   apiUrl = "https://stg-awsapi.e2m.live/reset-password";
      //   xAPIkey = "uucvCGcJNoapVT4XkwfBb23fWriuQYY968HueUUb";
      // } else {
      //   apiUrl = "https://awsapi.e2m.live/reset-password";
      //   xAPIkey = "uucvCGcJNoapVT4XkwfBb23fWriuQYY968HueUUb";
      // }

      debugger;

      var postData = {
        token: self.requestToken,

        data: {
          password: newPassword,
          confirmPassword: confirmPassword,
        },
      };
      let headers = {
        "content-type": "application/json",
      };
      axios
        .post(APIs.ResetPassword, JSON.stringify(postData), {
          headers: headers,
        })
        .then((response) => {
          that.changePasswordButtonLoading = false;
          if (response.data.status >= 0) {
            $("#btnChangePwd").val("Submit");
            document.getElementById("txtNewPassword").value = "";
            document.getElementById("txtConfirmNewPassword").value = "";
            self.showSnackbar(
              self.$t("myprofile.changedsuccesfully"),
              "success",
              "top"
            );
            self.$router.push("/");
          } else if (response.data.status == -2) {
            $("#btnChangePwd").val("Submit");
            document.getElementById("txtNewPassword").value = "";
            document.getElementById("txtConfirmNewPassword").value = "";

            self.showSnackbar(
              self.$t("myprofile.resetpasswordurlinvalid"),
              "error",
              "top"
            );
            that.changePasswordButtonLoading = false;
            return false;
          } else if (response.data.status == -3) {
            $("#btnChangePwd").val("Submit");
            document.getElementById("txtNewPassword").value = "";
            document.getElementById("txtConfirmNewPassword").value = "";

            self.showSnackbar(
              self.$t("myprofile.resetpasswordurlexpired"),
              "error",
              "top"
            );
            // $("#Othermsg-modal").modal("show");
            that.changePasswordButtonLoading = false;

            return false;
          }
        })
        .catch((error) => {
          that.changePasswordButtonLoading = false;
          // alert("FirebaseLoginWithAuth auth error");
          debugger;
          $("#btnChangePwd").val("Submit");
          document.getElementById("txtNewPassword").value = "";
          document.getElementById("txtConfirmNewPassword").value = "";
          document.getElementById("dvOtherMsg").value =
            self.$t("myprofile.errorinauthentication") + error;
          // $("#Othermsg-modal").modal("show");

          self.showSnackbar(
            self.$t("myprofile.errorinauthentication") + error,
            "error",
            "top"
          );
        });
    },
    getButtonBranding: function (hostName) {
      debugger;
      var path;
      if (hostName.toLowerCase().indexOf("uat") > -1) {
        path = "https://resources.e2m.live/uate2monair.appspot.com/";
      } else {
        path = "https://resources.e2m.live/e2monair.appspot.com/";
      }
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          debugger;
          self.btnBackColor = res.data.LoginAssets.loginButtonFillColor;
          self.btntextColor = res.data.LoginAssets.loginButtonTextColor;
          self.BannerURL = res.data.EventListAssets.banner2048x88;
          $("#btnChangePwd").css("background-color", self.btnBackColor);
          $("#btnChangePwd").css("color", self.btntextColor);
        });
      //------------------------------------------------------------------------------
    },
  },
};
</script>
